import axios from 'axios';

const SpawnSizes = [50274091, 25830791, 263383766, ];

export { SpawnSizes };

export default async function load_spawn(api, fs) {
  let file = fs.files.get('diabdat.mpq');
  if (file && !SpawnSizes.includes(file.byteLength)) {
    fs.files.delete('diabdat.mpq');
    await fs.delete('diabdat.mpq');
    file = null;
  }
  if (!file) {
    const spawn = await axios.request({
      url: process.env.PUBLIC_URL + '/diabdat.mpq',
      responseType: 'arraybuffer',
      onDownloadProgress: e => {
        if (api.onProgress) {
          api.onProgress({text: 'Downloading...', loaded: e.loaded, total: e.total || SpawnSizes[1]});
        }
      },
      headers: {
        'Cache-Control': 'max-age=31536000'
      }
    });
    if (!SpawnSizes.includes(spawn.data.byteLength)) {
      throw Error("Invalid diabdat.mpq size. Try clearing cache and refreshing the page.");
    }
    const data = new Uint8Array(spawn.data);
    fs.files.set('diabdat.mpq', data);
    fs.update('diabdat.mpq', data.slice());
  }
  return fs;
}
